<template>
  <div v-loading.sync="loading">
    <el-tabs @tab-click="changeTab" v-model="show">
      <el-tab-pane label="日报列表" name="TABLE" v-if="!pb">
        <div>
          <el-form class="table-form" size="small" ref="daily-report-search-form" :model="reportQuery"
                   label-width="80px"
                   inline @submit.native.prevent>
            <el-form-item prop="title" label="标题">
              <el-input v-model="reportQuery.title" placeholder="输入标题查询" @keyup.native.enter="fetchReports"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <el-divider>
          <span v-if="!reports.length">暂无数据</span>
          <span v-else>
            <el-pagination @current-change="fetchReports" small :page-size="reportPage.size"
                           :current-page.sync="reportPage.number" :total="reportPage.totalElements"
                           :page-count="reportPage.totalPages"
                           layout="prev, pager, next, ->, total, slot"></el-pagination>
          </span>
        </el-divider>
        <div v-for="r in reports" :key="r.id" style="margin: 5px 0">
          <daily-report-nav :report="r" @read="fetchItemList"/>
        </div>
      </el-tab-pane>
      <el-tab-pane label="日报详情" name="DETAIL" v-if="show === 'DETAIL'">
        <div style="text-align: right; margin: 0 8%" v-if="shareable && !pb">
          <el-button slot="reference" size="mini" icon="el-icon-share" @click="createShareUrl"></el-button>
        </div>
        <div>
          <el-form class="table-form" size="small" ref="daily-report-search-form" :model="reportQuery"
                   label-width="80px"
                   inline @submit.native.prevent>
            <el-form-item class="label-inline" label="关注项">
              <el-select class="inline-input" :value="selectedConcerned.title" clearable @change="selectConcerned">
                <el-option v-for="c in concernedSet" :key="c.id" :value="c">{{ c.title }}
                  （{{ countByConcerned(c) }} 项）
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="label-inline" prop="title" label="地区">
              <el-select class="inline-input" :value="selectedArea" clearable @change="selectArea">
                <el-option v-for="a in areaSet" :key="a" :value="a">{{ a }} （{{ countByArea(a) }} 项）</el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="label-inline" prop="title" label="标题">
              <el-input class="inline-input" v-model="itemQuery.title" placeholder="输入标题筛选"></el-input>
            </el-form-item>
            <el-form-item class="label-inline" :label="'查看建议(' + suggestItemsCount + ')'">
              <el-switch v-model="viewSuggest"></el-switch>
            </el-form-item>
            <el-form-item class="label-inline" :label="'查看弃用('+ unusedItemsCount + ')'" v-if="unusedItemsCount > 0">
              <el-switch v-model="viewUnuse"></el-switch>
            </el-form-item>
          </el-form>
        </div>
        <el-divider>
          <span class="text-nowrap" v-if="selectedConcerned.title || selectedArea">
            {{ selectedArea }}&nbsp;&nbsp;{{ selectedConcerned.title }}
          </span>
        </el-divider>
        <div v-for="(item, idx) in visibleItems" :key="item.id" style="margin: 5px 0">
          <daily-report-item-card :item="item" :index="idx + 1"
                                  @unuse="setItemUnUse"
                                  @suggest="setItemSuggest"
                                  @continue="setItemContinue"
                                  @operaEmpty="setItemOperaEmpty"
                                  @showCustomerInfos="toShowCustomerInfo"
                                  @changeItemConcerned="changeItemConcerned"
                                  :concerned-list="concernedSet"
                                  :highlight-titles="item.highlightTitles"></daily-report-item-card>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :visible.sync="showShareLink" title="点击复制">
      <div v-if="rid">
        <el-input type="textarea" readonly ref="share-url-item" :value="shareUrl()"></el-input>
      </div>
      <div v-if="!rid">尚未选择日报</div>
      <div slot="footer" v-if="rid">
        <el-button size="small" @click="copyShareUrl">复制</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="viewCustomerInfo" width="90%" style="padding: 5px" :title="searchedCustomerName + '相关动态'">
      <customer-search-component :customer-name="searchedCustomerName"></customer-search-component>
    </el-dialog>
  </div>
</template>

<script>
import DailyReportNav from "@/components/daily/DailyReportNav";
import DailyReport from "@/models/DailyReport";
import DailyReportService from "@/services/report/DailyReportService";
import DailyReportItem from "@/models/DailyReportItem";
import DailyReportItemCard from "@/components/daily/DailyReportItemCard";
import Page from "@/models/Page";
import ConcernedInfo from "@/models/ConcernedInfo";
import Configs from '@/configs'
import {mapGetters} from "vuex";
import CustomerSearchComponent from "@/components/search/CustomerSearchComponent";

export default {
  name: "DailyReportView",
  components: {CustomerSearchComponent, DailyReportItemCard, DailyReportNav},
  data() {
    return {
      reports: [],
      reportPage: new Page(),
      reportQuery: new DailyReport(),
      itemQuery: new DailyReportItem(),
      items: [],
      loading: false,
      show: 'TABLE',
      selectedConcerned: new ConcernedInfo(),
      selectedArea: '',
      rid: '',
      showShareLink: false,
      host: Configs.host,
      pb: false,
      viewUnuse: false,
      viewSuggest: false,
      viewCustomerInfo: false,
      searchedCustomerName: ''
    }
  },
  watch: {
    viewUnuse(n) {
      if (n) {
        this.viewSuggest = false
        this.viewCustomerInfo = false
      }
    },
    viewSuggest(n) {
      if (n) {
        this.viewUnuse = false
        this.viewCustomerInfo = false
      }
    },
    viewCustomerInfo(n) {
      if (n) {
        this.viewUnuse = false
        this.viewSuggest = false
      } else {
        this.searchedCustomerName = ''
      }
    }
  },
  mounted() {
    if (this.$route.path.startsWith("/public/daily")) {
      if (this.$route.query['rid']) {
        this.pb = true
        this.fetchItemList({id: this.$route.query['rid']})
      }
      if (this.$route.query['suggest']) {
        this.viewSuggest = true
      }
    } else {
      this.fetchReports()
    }
  },
  computed: {
    ...mapGetters({
      user: 'currentUser'
    }),
    shareable() {
      return this.user.isLogined()
    },
    unusedItemsCount() {
      return this.items.filter(i => i.unused).length
    },
    suggestItemsCount() {
      return this.items.filter(i => i.suggest).length
    },
    visibleItems() {
      let ret = this.items

      if (this.viewSuggest) {
        ret = ret.filter(i => i.suggest)
      }

      if (this.viewUnuse) {
        ret = ret.filter(i => i.unused)
      } else {
        ret = ret.filter(i => !i.unused)
      }
      if (this.itemQuery.title) {
        ret = ret.filter(i => i.title.indexOf(this.itemQuery.title) >= 0)
      }
      if (this.selectedConcerned && this.selectedConcerned.id) {
        ret = ret.filter(i => i.concerned && i.concerned.id === this.selectedConcerned.id)
      }
      if (this.selectedArea) {
        ret = ret.filter(i => i.firstLevelArea === this.selectedArea)
      }
      return ret
    },
    concernedSet() {
      return this.visibleItems
          .filter(i => i.concerned && i.concerned.id)
          .map(i => i.concerned)
          .distinct((c1, c2) => c1.id === c2.id)
    },
    areaSet() {
      return this.visibleItems
          .map(i => i.firstLevelArea)
          .filter(i => !!i)
          .distinct()
    },
    countByArea() {
      return (a) => {
        let ret = this.visibleItems;
        if (a) {
          ret = this.visibleItems.filter(i => i.firstLevelArea === a)
        } else {
          return 0
        }
        return ret.length
      }
    },
    selectable() {
      return this.concernedSet.length > 1
    }
  },
  methods: {
    shareUrl() {
      const content = this.concernedSet.map(c => {
        return c.title + this.countByConcerned(c) + " [" + " " + this.createConcernedAreaStr(c) + "] "
      }).join('、')
      const suggestStr = this.suggestItemsCount > 0 ? "建议关注项： " + this.suggestItemsCount + "项" : ""
      const itemCount = this.items.filter(i => !i.unused).length
      return `请点击以下链接进入日报详情(${itemCount}项)：\n${suggestStr}\n http://${this.host}/#/public/daily?rid=${this.rid} \n${content}`
    },
    createConcernedAreaStr(c) {
      let ret = this.items.filter(i => !i.unused);
      if (c && c.id) {
        ret = ret.filter(i => i.concerned && i.concerned.id === c.id)
      } else {
        return "";
      }
      let areas = ret.map(i => i.firstLevelArea)
          .filter(i => !!i)
          .distinct()
      return areas.map(a => {
        return a + ret.filter(i => i.firstLevelArea === a).length
      }).join(',')
    },
    copyShareUrl() {
      if (this.rid) {
        const ipt = this.$refs['share-url-item'];
        ipt.focus()
        ipt.select()
        document.execCommand('copy')
        ipt.blur()
        this.$message.success('已复制')
      }
    },
    fetchReports() {
      this.rid = ''
      this.loading = true
      DailyReportService.findSelfPage(this.reportQuery, this.reportPage.asQueryPage()).then(resp => {
        if (resp.status === 200) {
          this.reports = resp.data.content.map(r => new DailyReport(r))
          this.reportPage = Page.MapPageByResp(resp.data)
        }
      }).finally(() => this.loading = false)
    },
    selectConcerned(c) {
      this.selectedConcerned = new ConcernedInfo(c)
    },
    selectArea(a) {
      this.selectedArea = a
    },
    changeTab(tab) {
      if (tab.name === 'TABLE') {
        this.fetchReports()
      }
    },
    fetchItemList(r) {
      if (!r || !r.id) {
        return
      }
      this.rid = r.id;
      if (this.pb) {
        this.loading = true
        DailyReportService.findPublicItems(r.id)
            .then(this.extractListResponse)
            .finally(() => this.loading = false)
      } else {
        DailyReportService.findItems(r.id)
            .then(this.extractListResponse)
            .finally(() => this.loading = false)
      }
    },
    countByConcerned(c) {
      let ret = this.items.filter(i => !i.unused);
      if (c && c.id) {
        ret = ret.filter(i => i.concerned && i.concerned.id === c.id)
      } else {
        return 0;
      }
      return ret.length
    },
    createShareUrl() {
      this.showShareLink = true
    },
    setItemUnUse(item) {
      if (!item || !item.id) {
        return
      }
      this.loading = true
      DailyReportService.setItemUnused(item.id)
          .then(this.extractListResponse)
          .finally(() => this.loading = false)
    },
    setItemSuggest(item) {
      if (!item || !item.id) {
        return
      }
      this.loading = true
      DailyReportService.setItemSuggest(item.id)
          .then(this.extractListResponse)
          .finally(() => this.loading = false)
    },
    setItemContinue(item) {
      if (!item || !item.id) {
        return
      }
      this.loading = true
      DailyReportService.setItemContinue(item.id)
          .then(this.extractListResponse)
          .finally(() => this.loading = false)
    },
    setItemOperaEmpty(item) {
      if (!item || !item.id) {
        return
      }
      this.loading = true
      DailyReportService.setItemOperaEmpty(item.id)
          .then(this.extractListResponse)
          .finally(() => this.loading = false)
    },
    extractListResponse(resp) {
      if (resp.status === 200) {
        this.show = 'DETAIL'
        this.items = (resp.data || []).map(i => new DailyReportItem(i))
      }
    },
    toShowCustomerInfo(cn) {
      if (cn) {
        this.searchedCustomerName = cn
        this.viewCustomerInfo = true
      }
    },
    changeItemConcerned(evt) {
      var {id, cid} = evt || {}
      if (id && cid) {
        this.loading = true
        DailyReportService.changeItemConcerned(id, cid)
            .then(this.extractListResponse)
            .finally(() => this.loading = false)
      }
    }
  }
}
</script>

<style scoped>

</style>
